module.exports = __webpack_public_path__ + "static/media/8_The final lesson_CN.a943042f.txt";